/**
 * The "Overrides" section of the sliding job launch drawer.
 * Let the user specify overrides (args, config, entry point) for
 * what we are launching.
 */

import Popover from '@material-ui/core/Popover';
import React, {useState} from 'react';

import {Button} from '../../Button';
import {CodeEditor} from '../CodeEditor';
import {JobRun, JobRuns} from '../JobDetail/utilTypes';
import * as S from './JobDrawerOverrides.styles';
import {SelectRunPanel} from './SelectRunPanel';

type JobDrawerOverridesProps = {
  previousRuns: JobRuns;
  overrides: string;
  onOverridesChange: (value: string) => void;
  onSelectRun: (run: JobRun) => void;
  customRunColors: Record<string, string>;
};

export const JobDrawerOverrides = ({
  previousRuns,
  overrides,
  onOverridesChange,
  onSelectRun,
  customRunColors,
}: JobDrawerOverridesProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const onCloneFromClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const onPopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <S.LabelRow>
        <S.Label>Overrides</S.Label>
        {previousRuns.length > 0 && (
          <>
            <S.PasteFrom>
              <Button icon="copy" variant="ghost" onClick={onCloneFromClick}>
                Clone from...
              </Button>
            </S.PasteFrom>
            <Popover
              id="job-drawer-paste-from-popover"
              open={Boolean(anchorEl)}
              anchorEl={anchorEl}
              onClose={onPopoverClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}>
              <SelectRunPanel
                runs={previousRuns}
                customRunColors={customRunColors}
                onSelectRun={onSelectRun}
                onClose={onPopoverClose}
              />
            </Popover>
          </>
        )}
      </S.LabelRow>
      <CodeEditor
        value={overrides}
        language="json"
        onChange={onOverridesChange}
      />
    </>
  );
};
